/* eslint-disable react/require-default-props, react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { X, RefreshCw, Save } from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { BigHead } from '../../../../lib/core.cjs.development';

function AvatarEditModal({
  isOpen,
  onClose,
  onSave,
  isSaveDisabled,
  userAvatar,
  generateAvatar,
  departmentName,
  gender,
}) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={handleBackdropClick}
      onKeyDown={(e) => e.key === 'Escape' && onClose()}
      role="button"
      tabIndex={0}
    >
      <div className="relative w-full max-w-sm mx-4 rounded-xl border bg-background shadow-xl animate-in fade-in-0 zoom-in-95">
        {/* Close button */}
        <button
          type="button"
          className="absolute right-4 top-4 rounded-sm opacity-70 hover:opacity-100 transition-opacity z-10"
          onClick={onClose}
        >
          <X className="h-5 w-5" />
        </button>

        {/* Content */}
        <div className="p-6">
          {/* Header */}
          <div className="text-center mb-4">
            <h2 className="text-xl font-semibold">Edit Avatar</h2>
            <p className="text-sm text-muted-foreground mt-1">
              Generate a new look for your profile
            </p>
          </div>

          {/* Avatar Preview */}
          <div className="flex justify-center mb-6">
            <div className="w-48 h-48 rounded-full bg-gradient-to-br from-primary/10 to-primary/5 border-4 border-primary/20 overflow-hidden">
              <BigHead {...userAvatar} />
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              variant="outline"
              className="flex-1 gap-2"
              onClick={() => generateAvatar(departmentName, gender)}
            >
              <RefreshCw className="h-4 w-4" />
              Regenerate
            </Button>
            <Button className="flex-1 gap-2" onClick={onSave} disabled={isSaveDisabled}>
              <Save className="h-4 w-4" />
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

AvatarEditModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaveDisabled: PropTypes.bool,
  userAvatar: PropTypes.object,
  generateAvatar: PropTypes.func.isRequired,
  departmentName: PropTypes.string,
  gender: PropTypes.string,
};

export default AvatarEditModal;
